import React, { useState } from "react";
import "./experience.css";

import data from "../../data/data";
const Experience = () => {
    const [ active, setActive ] = useState(data.experience[0]);
    return (
        <section className="app__experience d-flex flex-item-center">
            <div className="app__experience-container app__container">
                <div className="app__experience-header">
                    <h2> Work & Experience </h2>
                </div>
                
                <div className="app__experience-body">
                    <div className="app__experience-row d-flex flex-item-between">
                        <div className="app__experience-nav">
                            { data.experience.map(experience => (
                                <div 
                                    className={`app__experience-nav_item ${active.id === experience.id && "-active"}`} 
                                    key={experience.id}
                                    onClick={() => setActive(experience)}
                                >
                                    <h4> { experience.company } </h4>
                                    <h6> { experience.start_date } - { experience.end_date } </h6>
                                </div>
                            ))}
                        </div>
                        <div className="app__experience-content">
                            <div className="app__experience-content_header">
                                <h4> { active.company } </h4>
                                <h6> { active.title } </h6>
                                <h6> { active.start_date } - { active.end_date } </h6>
                            </div>
                            { active.roles.map((role, index)=> (
                                <div className="app__experience-content_field d-flex flex-item-left gap-1" key={index}>
                                    <div className="-dot" />
                                    <p> { role } </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Experience;